import { httpRequest } from "@services/http";
import { bannersUrl } from "./cmdListBanners";

export class CommandDeleteBanner {
  async run(uuid: string): Promise<void> {
    try {
      await httpRequest<void>(`${bannersUrl()}${uuid}/`, { method: "DELETE" });
    } catch (error) {
      console.error("Error deleting banner:", error);
      throw error;
    }
  }
}
